// components/Navbar/NavbarBeforeLogin.jsx
import React, { useState, useEffect } from 'react';
import { HiMenuAlt3 } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import NavBrand from './NavBrand';

const NavbarBeforeLogin = () => {
    const [changeHeader, setChangeHeader] = useState(false);
    const [mobileNav, setMobileNav] = useState(false);

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'Services', path: '/services' },
        { name: 'Departments', path: '/departments' },
        { name: 'Doctors', path: '/doctors' },
        { name: 'Announcements', path: '/announcements' },
        { name: 'About Us', path: '/about' },
    ];

    const handleClick = () => {
        setMobileNav(!mobileNav);
    };

    const onChangeHeader = () => {
        if (window.scrollY >= 50) {
            setChangeHeader(true);
        } else {
            setChangeHeader(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onChangeHeader);
        return () => {
            window.removeEventListener('scroll', onChangeHeader);
        };
    }, []);

    return (
        <header className={changeHeader ? "bg-white fixed z-50 top-0 left-0 w-full shadow-md transition duration-500" : "bg-white fixed z-50 top-0 left-0 w-full transition duration-500"}>
            {/* desktop nav */}
            <nav className="flex items-center max-w-screen-xl mx-auto px-6 py-4">
                {/* brand */}
                <div className="flex flex-grow">
                    <NavBrand />
                </div>
                
                {/* desktop navigation links */}
                <div className="hidden md:flex items-center space-x-8">
                    {navLinks.map((link) => (
                        <Link
                            key={link.name}
                            to={link.path}
                            className="text-gray-700 hover:text-blue-600 font-medium transition duration-300"
                        >
                            {link.name}
                        </Link>
                    ))}
                    <Link
                        to="/login"
                        className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300 font-medium"
                    >
                        Login
                    </Link>
                </div>
                
                {/* mobile menu button */}
                <div className="block md:hidden">
                    <HiMenuAlt3 
                        className="w-10 h-10 text-gray-700 cursor-pointer p-2" 
                        onClick={handleClick} 
                    />
                </div>
            </nav>

            {/* mobile navigation */}
            {mobileNav && (
                <div className="md:hidden bg-white shadow-lg">
                    <div className="flex flex-col space-y-4 px-6 py-4">
                        {navLinks.map((link) => (
                            <Link
                                key={link.name}
                                to={link.path}
                                className="text-gray-700 hover:text-blue-600 py-2 font-medium"
                                onClick={() => setMobileNav(false)}
                            >
                                {link.name}
                            </Link>
                        ))}
                        <Link
                            to="/login"
                            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300 font-medium text-center"
                            onClick={() => setMobileNav(false)}
                        >
                            Login
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default NavbarBeforeLogin;